import { useEffect } from "react";
import BookingForm from "../components/BookingForm";
import Location from "../components/Location";

const ContactPage = () => {
  useEffect(() => {
    document.title = "Contact & Programări | MEDAS Stomatologie Timișoara";
  }, []);

  return (
    <div className="pt-[76px] md:pt-[112px]">
      <BookingForm />
      <Location />
    </div>
  );
};

export default ContactPage;
